import type { AxiosError } from 'axios';

type ErrorTitle = `${'GET' | 'POST' | 'PATCH' | 'DELETE'} ${string} Failed`;
type BffError = {
  details?: {
    method: 'get' | 'post' | 'patch' | 'delete';
    url: string;
  };
  errorCode?: number;
  flavorText?: string;
  stackTrace?: string;
  title?: string;
};

export const getErrorEventPayload = (title: ErrorTitle, error: AxiosError) => {
  const bffError = error?.response?.data as BffError | undefined;

  if (bffError) {
    return {
      errorMessage: title as string,
      errorSummary: `Title: ${bffError?.title ?? 'Unknown'} | Flavor Text: ${bffError?.flavorText ?? 'Unknown'}`,
      api: bffError?.details?.url ?? 'Unknown',
      errorCode: `${bffError?.errorCode ?? 'Unknown'}`,
      source: window.location.href,
    };
  } else {
    return {
      errorMessage: title as string,
      errorSummary: error?.message ?? 'Unknown',
      api: error?.request?.responseURL ?? 'Unknown',
      errorCode: `${error?.response?.status ?? 'Unknown'}`,
      source: window.location.href,
    };
  }
};
